export const formatCurrency = (
    value,
    currency = "EUR"
) => {

    return new Intl.NumberFormat(
        "tr-TR",
        {
            style: "currency",
            currency,
            minimumFractionDigits: 2
        }
    ).format(Number(value || 0));

};

export const formatPercent = (value) => {

    return `${Number(value || 0).toFixed(2)} %`;

};

export const formatNumber = (value) => {

    return new Intl.NumberFormat("tr-TR")
        .format(Number(value || 0));

};

export const formatDate = (date) => {

    if (!date)
        return "-";

    return new Date(date)
        .toLocaleDateString("tr-TR");

};